<template>
  <div class="login">
    <div class="container h-100vh">
      <div class="row justify-content-center align-items-center h-100vh">
        <div class="col-lg-5 col-md-7 py-3 py-lg-4 m-4 card border-0 login-shadow login-card">
          <!-- Header -->
          <div class="header">
            <div class="header-body text-center mb-3">
              <img alt="My Cloud" src="@/assets/img/brand/logo-round-sm.png" class="logo">
              <h1 class="mt-2 mb-0">LOGIN</h1>
            </div>
          </div>
          <!-- Page content -->
          <div class="card-body px-lg-5 py-lg-2">
            <form role="form" @submit.prevent="submitLogin">
              <div class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-success"><i class="ni ni-email-83"></i></span>
                  </div>
                  <input class="form-control" v-model="email" placeholder="Email" type="email">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-success"><i class="ni ni-lock-circle-open"></i></span>
                  </div>

                  <input :type="passwordVisible ? 'text' : 'password'" class="form-control" v-model="password"
                    placeholder="Password">

                  <!-- Toggle Visibility Icon -->
                  <div class="input-group-append">
                    <span class="input-group-text" @click="togglePasswordVisibility" style="cursor: pointer;">
                      <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                  </div>


                  <!-- <input class="form-control" v-model="password" placeholder="Password" type="password"> -->
                </div>
              </div>
              <div class="form-group d-flex align-items-center justify-content-between">
                <b-form-checkbox v-model="rememberMe">Remember Me</b-form-checkbox>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-success mt-4 mb-2" v-if="!loading"> Login </button>
                <button type="button" class="btn login_buttons px-4" v-if="loading">Loading</button>
                <!-- <button type="button" class="btn btn-primary my-4">Sign in</button> -->
              </div>
            </form>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <router-link :to="{ name: 'forgotPassword' }" class="nav-link">
                <small>Forgot password?</small>
              </router-link>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <small class="text-muted">{{ buildLabel }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    // Build identity injected by webpack DefinePlugin, e.g. "v3.0.0 · 56d12ab · 2026-10-26". 2026-10-26
    buildLabel: ['v' + process.env.APP_VERSION, process.env.APP_COMMIT, process.env.APP_BUILD_DATE].join(' · '),
    email: '',
    password: '',
    passwordVisible: false,
    loading: false,
    rememberMe: false
  }),
  computed: {
    ...mapGetters('authentication', ['userGetter',]),
    getData() {
      console.log(this.userGetter, "=====userGetter")
      if (this.userGetter) {
        if (localStorage.roleId == 1) {
          this.$router.replace({ name: "dashboard" });
        }
        if (localStorage.roleId == 2) {
          this.$router.replace({ name: "Home" });
        }
      }
    }
  },
  methods: {
    ...mapActions('authentication', ['LOGIN_SERVICE', 'GET_USER_DETAILS']),
    submitLogin() {
      this.$router.replace({ name: "dashboard" });
      this.loading = true;
      var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
      if (this.email != '' && this.password != '') {
        var body = {
          email: this.email,
          password: this.password,
          source: 'web'
        }
        if (re.test(this.email)) {
          this.LOGIN_SERVICE(body).then(() => {
            if (this.rememberMe) {
              localStorage.setItem('rememberedEmail', this.email);
            } else {
              localStorage.removeItem('rememberedEmail');
            }
            this.loading = false;

            if (localStorage.roleId == 1) {
              this.$router.replace({ name: "dashboard" });
            }
            if (localStorage.roleId == 2) {
              this.$router.replace({ name: "Home" });
            }
          }).catch((e) => {
            this.loading = false;
          })
        } else {
          this.loading = false;
          this.ERROR_TOAST_MSG('Enter Valid Email');
        }
      } else {
        this.loading = false;
        this.ERROR_TOAST_MSG('Enter All fields');
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;  // Toggle the password visibility
    },
    adminLogin() {
      this.$router.replace({ name: "Home" });
    }
  },
  created() {
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    if (rememberedEmail) {
      this.email = rememberedEmail;
      this.rememberMe = true;
    }

    // Clear other login session data but keep remembered email
    const remembered = localStorage.getItem('rememberedEmail');
    localStorage.clear();
    if (remembered) localStorage.setItem('rememberedEmail', remembered);
}
}
</script>

<style scoped>
.login-card {
  position: relative;
  overflow: hidden;
  border-radius: 1.2rem;
  box-shadow: 0 22px 48px rgba(31, 41, 55, 0.12);
}

.login-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top right, rgba(76, 182, 255, 0.2), transparent 34%),
    radial-gradient(circle at bottom left, rgba(115, 199, 97, 0.16), transparent 30%),
    linear-gradient(135deg, rgba(76, 182, 255, 0.1) 0%, rgba(255, 255, 255, 0.97) 56%, rgba(115, 199, 97, 0.08) 100%);
  pointer-events: none;
}

.login-card > * {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/Authenticaion/adminLogin.vue